import React, { createContext, useState, type JSX } from 'react';
import type { FullUser } from '@/types/user';
import { EngineService } from '@/services/engine/engine-service';
import { useAuthUser } from '@/hooks/useAuthUser';

export type AuthContextType = {
    user: FullUser | null;
    isAuthenticated: boolean;
    isLoading: boolean;
    isLoggingOut: boolean;
    logout: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextType | null>(null);

export function AuthProvider({
    children,
}: {
    children: React.ReactNode;
}): JSX.Element {
    const { user, isLoading, mutate } = useAuthUser();
    const [isLoggingOut, setIsLoggingOut] = useState<boolean>(false);

    const contextValue: AuthContextType = {
        user,
        isAuthenticated: !!user,
        isLoading,
        isLoggingOut,
        logout: async () => {
            setIsLoggingOut(true);
            await mutate(null, { revalidate: false });
            EngineService.logout();
        },
    };

    return (
        <AuthContext.Provider value={contextValue}>
            {children}
        </AuthContext.Provider>
    );
}
